module.exports = __webpack_public_path__ + "img/16.52408180.png";